import script from "./cnt-tiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-tiles.vue?vue&type=script&lang=ts&setup=true"

import "./cnt-tiles.vue?vue&type=style&index=0&id=c9336a24&lang=scss"

const __exports__ = script;

export default __exports__